import { render, staticRenderFns } from "./SimTable.vue?vue&type=template&id=0db2ab39&scoped=true"
import script from "./SimTable.vue?vue&type=script&lang=ts"
export * from "./SimTable.vue?vue&type=script&lang=ts"
import style0 from "./SimTable.vue?vue&type=style&index=0&id=0db2ab39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2ab39",
  null
  
)

export default component.exports